export default __webpack_public_path__ + "static/media/broken-heart.f0d66934.png";